import { useCallback } from 'react';
import { useLocation } from 'react-router';

import { useLatest } from 'hooks/useLatest';
import type { SearchFromPageType } from 'modules/search/types/SearchFromPageType';

import { useSearchGetTrackingData } from './analytics/useSearchGetTrackingData';

type LocationState = {
  searchFrom?: string;
  searchFromPageType?: SearchFromPageType;
};

export function useSearchAnalytics() {
  const location = useLocation<LocationState>();

  // Don't trigger analytics change just because the searchFrom value changed
  const searchFromRef = useLatest(location.state?.searchFrom);
  const searchFromPageTypeRef = useLatest(location.state?.searchFromPageType);

  const { searchGetTrackingData } = useSearchGetTrackingData();

  const getSearchTrackingData = useCallback(
    () =>
      searchGetTrackingData({
        searchFrom: searchFromRef.current,
        searchFromPageType: searchFromPageTypeRef.current,
      }),
    [searchGetTrackingData, searchFromPageTypeRef, searchFromRef],
  );

  return { getSearchTrackingData };
}
